import EmailForm from "./EmailForm";

export default EmailForm;
